/**
 * アプリケーション個別で値が変わる定数値
 */
export const APPLICATION_NAME = 'management-dx';
export const APPLICATION_JAPANESE_NAME = 'バニラJavaScript';
/**
 * ページング関連の定数
 */
export const DEFAULT_PAGE_SIZE = 100;
export const MAX_PAGE_SIZE = 1000;
export const MIN_PAGE_SIZE = 1;
/**
 * マスキング関連の定数
 */
export const UNDISPLAY_ITEM = "UNDISPLAY_ITEM";
export var Mode;
(function (Mode) {
    Mode["LOGIN"] = "LOGIN-MODE";
    Mode["MAIN"] = "MAIN-MODE";
})(Mode || (Mode = {}));
